class Stats {
    statsWrappers: NodeListOf<HTMLElement>;
    statCircles: NodeListOf<HTMLElement>;

    constructor() {
        this.init();
    }

    init() {
        this.statsWrappers = document.querySelectorAll('.stats-wrap');
        //this.statCircles = document.querySelectorAll('.underlay-chart[data-triggered="0"]');
    }

    start() {
        const self = this;
        window.addEventListener('scroll', function(){
            const bottomOfScreen = this.innerHeight;
            const topOfScreen = this.scrollY;
            if(self.statsWrappers != null){
                self.statsWrappers.forEach(stat => {
                    const circle = <HTMLElement> stat.querySelector('.underlay-chart');
                    const topOfStat = <number> stat.getBoundingClientRect().top;
                    const bottomOfStat = <number> stat.getBoundingClientRect().bottom;
                    if (typeof Element.prototype.getBoundingClientRect === 'function') {
                        //Client supports getBoundingClientRect()
                        if((bottomOfScreen > (topOfStat - 20))){
                            self.animateStat(stat, circle);
                        }
                    } else {
                        //no animation for old browsers !!
                        stat.classList.add('animated');
                        stat.dataset.triggered = '1';
                        circle.dataset.triggered = '1';
                    }
                    
                })
            }

            //if(self.statCircles != null){
            //    self.statCircles.forEach(circle => {
            //        const topOfCircle = <Number> circle.getBoundingClientRect().top;
            //        const bottomOfCircle = <Number> circle.getBoundingClientRect().bottom;
            //        if((bottomOfScreen > topOfCircle) && (topOfScreen < bottomOfCircle)){
            //            if(circle.dataset.triggered === undefined){
            //                circle.dataset.triggered = '0';
            //            }
            //            if(circle.dataset.triggered == '0'){
            //                circle.dataset.triggered = '1';
            //            }
            //        }
            //    });
            //}
        })
        window.addEventListener('load', function(){
            const bottomOfScreen = this.innerHeight;
            const topOfScreen = this.scrollY;
            if(self.statsWrappers != null){
                self.statsWrappers.forEach(stat => {
                    const circle = <HTMLElement> stat.querySelector('.underlay-chart');
                    const topOfStat = <number> stat.getBoundingClientRect().top;
                    const bottomOfStat = <number> stat.getBoundingClientRect().bottom;
                    if (typeof Element.prototype.getBoundingClientRect === 'function') {
                        //Client supports getBoundingClientRect()
                        if((bottomOfScreen > (topOfStat - 20)) && (topOfScreen < bottomOfStat)){
                            self.animateStat(stat, circle);
                        }
                    } else {
                        //no animation for old browsers !!
                        stat.classList.add('animated');
                        stat.dataset.triggered = '1';
                        circle.dataset.triggered = '1';
                    }
                })
            }
        })
    }

    animateStat(stat, circle){
        if(stat.dataset.triggered === undefined){
            stat.dataset.triggered = '0';
            circle.dataset.triggered = '0';
        }
        if(stat.dataset.triggered == '0'){
            stat.classList.add('animated');
            stat.dataset.triggered = '1';
            circle.dataset.triggered = '1';
        }
    }
}

export default Stats;